/* @flow */
import * as React from 'react';

const ArrowBigGrayDown = props => (
  <svg width={16} height={24} viewBox="0 0 16 24" {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill="#848794"
      fillRule="evenodd"
      opacity={0.5}
      d="M7,1.031 L7,20.111 L1.257,14.439 C0.983,14.136 0.522,14.437 0.229,14.721 C0.077,14.869 0,15.068 0,15.268 C0,15.452 0.065,15.637 0.197,15.781 L7.47,23.766 C7.53,23.826 7.564,23.836 7.593,23.857 C7.656,23.899 7.682,23.926 7.713,23.94 C7.776,23.964 7.821,23.967 7.865,23.975 C7.907,23.983 7.947,23.999 7.99,24 C8.054,23.999 8.094,23.983 8.136,23.975 C8.181,23.966 8.225,23.964 8.267,23.947 C8.319,23.926 8.344,23.899 8.374,23.881 C8.438,23.836 8.471,23.826 8.498,23.8 C8.524,23.77 15.803,15.782 15.803,15.782 C16.077,15.481 16.064,15.007 15.771,14.722 C15.479,14.438 15.018,14.137 14.743,14.439 L9,20.111 L9,1.031 C9,0.617 8.402,0 8,0 C7.599,0 7,0.617 7,1.031 Z"
    />
  </svg>
);

export default ArrowBigGrayDown;



// WEBPACK FOOTER //
// ./src/assets/images/icons/arrow-big-gray-down.js